import QuestionNavigator from './QuestionNavigator';
export default QuestionNavigator;